import {
  oidcCallbackPath as handshakeOidcCallbackPath,
  samlSpAcsPath as handshakeSpAcsPath,
  samlSpMetadataPath as handshakeSpMetadataPath,
} from "../../../../shared/ssoHandshakePaths";
import { scimV2Path } from "../../../lib/apiPaths";
import { apiUrl } from "../../../lib/tenantOrigin";

// The SP entity ID, ACS, and OIDC redirect URI must match what the server
// mints into SSO handshakes (services/api/lib/sso/handshakeOrigin.ts):
// canonical /sso on the app origin.
const SSO_HANDSHAKE_PREFIX = "/sso";

export function spMetadataUrl(identityOrigin: string, providerId: string) {
  return `${identityOrigin}${handshakeSpMetadataPath(SSO_HANDSHAKE_PREFIX, providerId)}`;
}

export function spEntityId(apiUrl: string) {
  return apiUrl;
}

export function spAcsUrl(identityOrigin: string, providerId: string) {
  return `${identityOrigin}${handshakeSpAcsPath(SSO_HANDSHAKE_PREFIX, providerId)}`;
}

export function oidcRedirectUri(identityOrigin: string, providerId: string) {
  return `${identityOrigin}${handshakeOidcCallbackPath(SSO_HANDSHAKE_PREFIX, providerId)}`;
}

export function scimBaseUrl() {
  return `${apiUrl()}${scimV2Path}`;
}
